import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/view/observer/bubblingeventinfo
 */
import { EventInfo } from '@ckeditor/ckeditor5-utils';
/**
 * The event object passed to bubbling event callbacks. It is used to provide information about the event as well as a tool to
 * manipulate it.
 */
var BubblingEventInfo = /*#__PURE__*/function (_EventInfo) {
  _inherits(BubblingEventInfo, _EventInfo);
  var _super = _createSuper(BubblingEventInfo);
  /**
   * @param source The emitter.
   * @param name The event name.
   * @param startRange The view range that the bubbling should start from.
   */
  function BubblingEventInfo(source, name, startRange) {
    var _this;
    _classCallCheck(this, BubblingEventInfo);
    _this = _super.call(this, source, name);
    _this.startRange = startRange;
    _this._eventPhase = 'none';
    _this._currentTarget = null;
    return _this;
  }
  /**
   * The current event phase.
   */
  _createClass(BubblingEventInfo, [{
    key: "eventPhase",
    get: function get() {
      return this._eventPhase;
    }
    /**
     * The current bubbling target.
     */
  }, {
    key: "currentTarget",
    get: function get() {
      return this._currentTarget;
    }
  }]);
  return BubblingEventInfo;
}(EventInfo);
export { BubblingEventInfo as default };